var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"8","fill":"#ECF3FB","key":0}),React.createElement("path",{"d":"M4.61014 8.49026L6.99051 11.2597L12.9506 5.88808","stroke":"#318EFF","key":1})]);
}

Checkmark.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
